import styles from "../../../../styles/finder/finder.module.scss"
import Image from "next/image"
import { useEffect, useMemo, useState } from "react"
import CheckBox from "../../checkbox/checkbox"
import { STEPS, useUserStore, useWizardStore } from "../store/finder_store"
import { haversineDistance, parseCoordinates } from "../store/nominatim"
import StyledText from "../../../typography/typography-component"
import skColors from "../../../../styles/skColors"
import Button from "../../Button/Button"
import { useTranslations } from "next-intl"
import { oneDoctorByOffice, GermanStates } from "../data/doctors"
import DoctorMapOverview from "./DoctorMapOverview"

const APPOINTMENT_URL = "https://erp.skinuvita.com/"

const Step3b = ({ onDisabledChange }: { onDisabledChange: (value: boolean) => void }) => {
  const t = useTranslations("index.finder")
  //READ healthInsurance from store
  const { plz, nominatimResponse, healthInsurance } = useUserStore()
  const { setStep } = useWizardStore()



  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    onDisabledChange(plz.length !== 5)
  }, [onDisabledChange, plz])

  // allowed states for Barmer filter(basic js filter)
  const ALLOWED_STATE_KEYWORDS = [GermanStates.LowerSaxony, GermanStates.Bremen, GermanStates.Hamburg]

  const isBarmerSelected = !!healthInsurance && healthInsurance.includes("BARMER")

  const filteredDoctors = useMemo(() => {
    const userLat = parseCoordinates(nominatimResponse?.lat ?? 0)
    const userLon = parseCoordinates(nominatimResponse?.lon ?? 0)

    return oneDoctorByOffice
      .map((doctor) => {
        const distanceKm = Number(
          haversineDistance({ lat1: doctor.lat, lon1: doctor.lon }, { lat2: userLat, lon2: userLon }).toFixed(0)
        )

        return { ...doctor, distanceKm }
      })
      .filter((doctor) => {
        if (isBarmerSelected) {
          return doctorStateMatchesAllowed(doctor.state)
        }

        return true
      })
      .sort((a, b) => a.distanceKm - b.distanceKm)
  }, [isBarmerSelected, nominatimResponse?.lat, nominatimResponse?.lon])

  // helper to check doctor's state matches one of the allowed ones
  const doctorStateMatchesAllowed = (doctorState: GermanStates) => {
    return ALLOWED_STATE_KEYWORDS.includes(doctorState)
  }

  return (
    <div className={styles.step1Content}>
      <StyledText variant="h3" color={skColors.turquoise[600]}>
        {t("step1.title")}
      </StyledText>
      <div className={styles.successSection} style={{ marginTop: "16px", marginBottom: "16px" }}>
        {/* ---------- LINE 1 ---------- */}

        <StyledText variant="h5">
          {t("step3b.listIntro")}
        </StyledText>
          <StyledText   variant="pRegular" color={skColors.darkgreen[600]}>
            {t("step3b.listIntro2")}
          </StyledText>
      </div>

      {/* Opened in a new tab instead of an iframe: cross-origin embedding blocks
          third-party cookies (Safari) and parent-frame access in the ERP app. */}
      <div className={styles.appointmentCard}>
        <StyledText variant="h4" color={skColors.darkgreen[600]}>
          {t("step3b.appointment.title")}
        </StyledText>
        <ol className={styles.appointmentSteps}>
          {[1, 2, 3].map((n) => (
            <li key={n} className={styles.appointmentStep}>
              <span className={styles.appointmentStepNumber}>{n}</span>
              <StyledText as="span" variant="pRegular" color={skColors.darkgreen[600]}>
                {t(`step3b.appointment.step${n}`)}
              </StyledText>
            </li>
          ))}
        </ol>
        <Button variant="primary" onClick={() => window.open(APPOINTMENT_URL, "_blank", "noopener,noreferrer")}>
          {t("buttons.bookAppointment")}
        </Button>
        <StyledText as="span" variant="pRegular" size={12} color={skColors.darkgreen[500]}>
          {t("step3b.appointment.hint")}
        </StyledText>
      </div>

      <DoctorMapOverview doctors={filteredDoctors} />

      {/*<div className={styles.doctorsList}>*/}
      {/*  {doctors*/}
      {/*    .map((doctor) => ({*/}
      {/*      ...doctor,*/}
      {/*      distance: haversineDistance(*/}
      {/*        {*/}
      {/*          lat1: doctor.lat,*/}
      {/*          lon1: doctor.lon,*/}
      {/*        },*/}
      {/*        {*/}
      {/*          // Use API lat/lon if available.*/}
      {/*          // If nominatimResponse is undefined (e.g. API not loaded yet),*/}
      {/*          // fallback to 0 to prevent runtime crash.*/}
      {/*          // parseCoordinates converts string values to numbers for distance calculation.*/}
      {/*          lat2: parseCoordinates(nominatimResponse?.lat ?? 0),*/}
      {/*          lon2: parseCoordinates(nominatimResponse?.lon ?? 0),*/}
      {/*        }*/}
      {/*      ).toFixed(0),*/}
      {/*    }))*/}
      {/*    //if Barmer is selected, filter to only allowed states*/}
      {/*    .filter((doctor) => {*/}
      {/*      if (isBarmerSelected) {*/}
      {/*        //only show doctors from the 3 allowed states*/}
      {/*        return doctorStateMatchesAllowed(doctor.state)*/}
      {/*      }*/}
      {/*      //otherwise show everyone*/}
      {/*      return true*/}
      {/*    })*/}
      {/*    .sort((a, b) => Number(a.distance) - Number(b.distance))*/}
      {/*    .map((doctor, iterator) => {*/}
      {/*      const distanceKm = Number(*/}
      {/*        haversineDistance(*/}
      {/*          { lat1: doctor.lat, lon1: doctor.lon },*/}
      {/*          {*/}
      {/*            lat2: parseCoordinates(nominatimResponse?.lat ?? 0),*/}
      {/*            lon2: parseCoordinates(nominatimResponse?.lon ?? 0),*/}
      {/*          }*/}
      {/*        ).toFixed(0)*/}
      {/*      )*/}
      {/*      return (*/}
      {/*        <div key={doctor.doctorsName + iterator} className={styles.doctorInfoContainer}>*/}
      {/*          <StyledText*/}
      {/*            style={{*/}
      {/*              alignSelf: "center",*/}
      {/*              marginBottom: "6px",*/}
      {/*            }}*/}
      {/*            variant={"h6"}*/}
      {/*            color={skColors.darkgreen[600]}*/}
      {/*          >*/}
      {/*            {doctor.doctorsName}*/}
      {/*          </StyledText>*/}
      {/*          <a target={"_blank"} rel={"noreferrer"} href={doctor.webAddress}>*/}
      {/*            <div className={styles.doctorsVariable}>*/}
      {/*              <Image*/}
      {/*                width={18}*/}
      {/*                height={18}*/}
      {/*                src={"/svg/home.svg"}*/}
      {/*                alt={""}*/}
      {/*                style={{*/}
      {/*                  marginRight: "8px",*/}
      {/*                  maxWidth: "100%",*/}
      {/*                  height: "auto",*/}
      {/*                }}*/}
      {/*              ></Image>*/}
      {/*              <div className={styles.constrainToTwoLines}>*/}
      {/*                <StyledText variant={"pRegular"}>{doctor.officeName}</StyledText>*/}
      {/*              </div>*/}
      {/*            </div>*/}
      {/*          </a>*/}
      {/*          <a target={"_blank"} rel={"noreferrer"} href={`https://www.google.de/search?q=${doctor.address}`}>*/}
      {/*            <div className={styles.doctorsVariable}>*/}
      {/*              <Image*/}
      {/*                width={18}*/}
      {/*                height={18}*/}
      {/*                src={"/svg/location.svg"}*/}
      {/*                alt={""}*/}
      {/*                style={{*/}
      {/*                  marginRight: "8px",*/}
      {/*                  maxWidth: "100%",*/}
      {/*                  height: "auto",*/}
      {/*                }}*/}
      {/*              ></Image>*/}
      {/*              <StyledText color={skColors.darkgreen[600]} variant={"pRegular"}>*/}
      {/*                {doctor.address}*/}
      {/*              </StyledText>*/}
      {/*            </div>*/}

      {/*            <div style={{ marginLeft: "26px", marginTop: "-4px" }} className={styles.doctorsVariable}>*/}
      {/*              <StyledText color={skColors.darkgreen[500]} size={11} variant={"pRegular"}>*/}
      {/*                {t("step3b.distanceKm", { km: distanceKm })}*/}
      {/*              </StyledText>*/}
      {/*            </div>*/}
      {/*          </a>*/}
      {/*          <a href={`tel:${doctor.phone}`}>*/}
      {/*            <div className={styles.doctorsVariable}>*/}
      {/*              <Image*/}
      {/*                width={18}*/}
      {/*                height={18}*/}
      {/*                src={"/svg/phone2.svg"}*/}
      {/*                alt={""}*/}
      {/*                style={{*/}
      {/*                  marginRight: "8px",*/}
      {/*                  maxWidth: "100%",*/}
      {/*                  height: "auto",*/}
      {/*                }}*/}
      {/*              ></Image>*/}
      {/*              <StyledText variant={"pRegular"}>{doctor.phone}</StyledText>*/}
      {/*            </div>*/}
      {/*          </a>*/}
      {/*          {doctor?.email && (*/}
      {/*            <a href={`mailto:${doctor.email}`}>*/}
      {/*              <div style={{ color: skColors.turquoise[500] }} className={styles.doctorsVariable}>*/}
      {/*                <Image*/}
      {/*                  width={18}*/}
      {/*                  height={18}*/}
      {/*                  src={"/svg/mail.svg"}*/}
      {/*                  alt={""}*/}
      {/*                  style={{*/}
      {/*                    marginRight: "8px",*/}
      {/*                    maxWidth: "100%",*/}
      {/*                    height: "auto",*/}
      {/*                  }}*/}
      {/*                ></Image>*/}
      {/*                <StyledText style={{ color: skColors.turquoise[500] }} variant={"pRegular"}>*/}
      {/*                  {doctor.email}*/}
      {/*                </StyledText>*/}
      {/*              </div>*/}
      {/*            </a>*/}
      {/*          )}*/}
      {/*          <a target={"_blank"} rel={"noreferrer"} href={doctor.webAddress}>*/}
      {/*            <div style={{ color: skColors.turquoise[500] }} className={styles.doctorsVariable}>*/}
      {/*              <Image*/}
      {/*                width={18}*/}
      {/*                height={18}*/}
      {/*                src={"/svg/web.svg"}*/}
      {/*                alt={""}*/}
      {/*                style={{*/}
      {/*                  marginRight: "8px",*/}
      {/*                  maxWidth: "100%",*/}
      {/*                  height: "auto",*/}
      {/*                }}*/}
      {/*              ></Image>*/}
      {/*              <StyledText style={{ color: skColors.turquoise[500] }} variant={"pRegular"}>*/}
      {/*                Website*/}
      {/*              </StyledText>*/}
      {/*            </div>*/}
      {/*          </a>*/}
      {/*        </div>*/}
      {/*      )*/}
      {/*    })}*/}
      {/*  <div></div>*/}
      {/*</div>*/}
    </div>
  )
}

export default Step3b
